import StyleButton from './StyleButton';

export default StyleButton;
